import { useRouter } from "next/router";
import React, { useEffect } from "react";
import { Portal } from "react-portal";
import { CSSTransition } from "react-transition-group";

import useDialog from "@/hooks/useDialog";

import styles from "./styles.module.css";
import { View } from "./View";

export const Dialog = () => {
  const {
    dialogTitle,
    dialogContents,
    isDialogVisible,
    dismissDialog,
    dialogSize,
    dialogTheme,
  } = useDialog();
  // Close cart when changing routes
  const router = useRouter();
  useEffect(() => {
    const handleRouteChange = () => {
      dismissDialog();
    };
    router.events.on("routeChangeStart", handleRouteChange);
    return () => {
      router.events.off("routeChangeStart", handleRouteChange);
    };
  }, []);
  return (
    <Portal>
      <CSSTransition
        in={isDialogVisible}
        unmountOnExit
        classNames={{
          enter: styles.enter,
          enterActive: styles.enterActive,
          exit: styles.exit,
          exitActive: styles.exitActive,
        }}
        addEndListener={(node, done) => {
          const notificationEl = node.querySelector("#dialog");
          notificationEl.addEventListener("transitionend", done, false);
        }}
      >
        <View
          title={dialogTitle}
          dismissDialog={dismissDialog}
          dialogSize={dialogSize}
          dialogTheme={dialogTheme}
        >
          {dialogContents}
        </View>
      </CSSTransition>
    </Portal>
  );
};
